const DJB_TYPE = 0x05

export const decodePoint = (bytesArray, offset) => {
  const byteArray = new Uint8Array(bytesArray)
  // eslint-disable-next-line no-bitwise
  const type = (0xff & byteArray[offset])

  if (type === DJB_TYPE) {
    return bytesArray.slice(1, 33)
  }

  return null
}
